import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import styles from './styles/Button.module.css';

export default function Button({
    children,
    onClick,
    type = 'button',
    variant = 'primary',
    size = 'medium',
    loading = false,
    disabled = false,
    className = '',
    ...props
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`${styles.button} ${styles[variant]} ${styles[size]} ${className}`}
            {...props}
        >
            {loading ? (
                <>
                    <FaSpinner className={styles.spinner} />
                    <span>Chargement...</span>
                </>
            ) : (
                children
            )}
        </button>
    );
}
